import { Component, OnInit, Input } from '@angular/core';
import { environment } from '@env/environment';
import { Store } from '@ngrx/store';
import { IAppState } from '@app/store';
import { Picture } from '@vestiaire/api-sdk-angular';
import { MagnifyOption } from '@app/shared/directives/magnify/magnify.model';
import { GalleryService, GalleryPicture } from '@app/+product/gallery/gallery.service';
import { ImagesService } from '../images/services/images.service';

@Component({
  selector: 'vc-carousel-images',
  templateUrl: './carousel-images.component.html',
  styleUrls: ['./carousel-images.component.scss']
})
export class CarouselImagesComponent implements OnInit {
  @Input() pictures: Array<Picture>;
  @Input() currentSlide: number;
  @Input() openDialogEnabled = false;
  @Input() showArrowsOnBigImg = true;
  @Input() lensEnabled = false;
  @Input() contextCssClass = '';
  @Input() defaultAlt = '';
  @Input() productPath: string;

  thumbsNbItems = 5;

  mainPictureIndex = 0;
  thumbsPictureIndex = 0;

  isMobile = false;
  isTablet = false;
  isDesktop = false;

  lensOptions: MagnifyOption = {
    zoom: 2,
    height: 300,
    width: 300,
    border: 2,
    borderColor: '#eaeaea',
    boxShadow: '0 2px 20px 0 rgba(0,0,0,0.20)'
  };

  picture: Picture;

  // Thumnails arrows buttons
  prevButtonDisabled = true;
  nextButtonDisabled = false;

  public imgSEOPath = '';
  public imgsSEOPath = Array();

  constructor(private store: Store<IAppState>, private galleryService: GalleryService) {}

  ngOnInit() {
    this._initDevice();
    // this.picture = this.pictures && this.pictures[0];
    this.galleryService.currentIndex.subscribe({
      next: index => this.display(index),
      error: err => console.error(err)
    });
    this.imgSEOPath = this.getSEOImgPath(this.picture?.path);
    this.imgsSEOPath = this.pictures.map(picture => {
      return this.getSEOImgPath(picture.path);
    });
  }

  getSEOImgPath(imgPath) {
    return ImagesService.improveSEOProductPathImg(imgPath, this.productPath);
  }

  private _initDevice() {
    this.store.select('device').subscribe(
      res => {
        if (res) {
          this.isMobile = !res.isMdUp;
          this.isTablet = !this.isMobile && res.isTouch;
          this.isDesktop = !this.isMobile && !this.isTablet;
        }
      },
      () => {
        // silent catch nothing to do
      }
    );
  }

  openDialog(event) {
    const initiator = event.target.parentElement.querySelector('img');

    const toGalleryPicture = (p: Picture, index): GalleryPicture => ({
      src: ImagesService.buildUrl(`/produit/${p.path}`, { w: p.width || 1000 }),
      // TODO Should be only on clicked elem, + exist somewher in this component not in vc-image
      msrc: index === this.mainPictureIndex ? initiator.src : undefined,
      w: p.width || 1400, // TODO How do we define the height of the image (know it can be zoomed 2x) ?
      h: p.height || 1400
    });

    const srcs = this.pictures.map(toGalleryPicture);
    this.galleryService.open(srcs, this.mainPictureIndex, initiator);
  }

  display(index: number) {
    this.picture = this.pictures[index];
    this.imgSEOPath = this.getSEOImgPath(this.picture?.path);
    this.mainPictureIndex = index;
    this.thumbsPictureIndex = index;
  }

  scrollToNext(el: HTMLElement) {
    const top = el.scrollTop + el.offsetHeight;
    el.scrollTo({ top, behavior: 'smooth' });
  }

  scrollToPrev(el: HTMLElement) {
    const top = el.scrollTop - el.offsetHeight;
    el.scrollTo({ top, behavior: 'smooth' });
  }

  onThumbScroll(el: HTMLElement) {
    // This function will be triggered a lot, do not do complex computing inside, or use debounce.
    const { scrollTop, scrollHeight, offsetHeight } = el;
    this.prevButtonDisabled = scrollTop === 0;
    this.nextButtonDisabled = scrollHeight - (scrollTop + offsetHeight) === 0;
  }
}
